import { useEffect, useState } from "react";

export const ProgressBar = ({ bgcolor, completed, amount, name, srNo }) => {
  const [fillWidth, setFillWidth] = useState("0%");

  useEffect(() => {
    const timeout = setTimeout(() => {
      setFillWidth(`${completed}%`);
    }, 100); 

    return () => clearTimeout(timeout);
  }, [completed]);

  const containerStyles = {
    height: 20,
    width: "100%",
    backgroundColor: "#EBE8F7",
    borderRadius: 50,
    overflow: "hidden",
    marginTop: 6,
    marginBottom: 12,
  };

  const fillerStyles = {
    height: "100%",
    width: fillWidth,
    backgroundColor: bgcolor,
    borderRadius: "inherit",
    transition: "width 1.3s ease-in-out",
    minWidth: completed > 0 ? "10%" : "0%", 
  };

  return (
    <div className="w-full">
      {/* Top Row */}
      <div
        className="flex justify-between items-center"
        style={{ fontSize: "14px", letterSpacing: "0.5px", marginBottom: "4px" }}
      >
        <div className="flex flex-row gap-2">
          <span>{srNo}.</span>
          <span className="capitalize">{name}</span>
        </div>
        <span className="font-medium">Rs.{Number(amount).toLocaleString("en-IN")}</span>
      </div>

      {/* Bar */}
      <div style={containerStyles}>
        <div style={fillerStyles}></div>
      </div>
    </div>
  );
};
